import React from 'react';

const ServicesPrice = ({ onOpenApplicationModal }) => {
    const services = [
        {
            title: 'Консультация и подбор автомобиля',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                    <polyline points="3.27,6.96 12,12.01 20.73,6.96"></polyline>
                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
            )
        },
        {
            title: 'Полная проверка нашими экспертами в Европе',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"></path>
                    <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"></path>
                </svg>
            )
        },
        {
            title: 'Сопровождение сделки',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
                </svg>
            )
        },
        {
            title: 'Информирование и отчеты клиенту',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10,9 9,9 8,9"></polyline>
                </svg>
            )
        },
        {
            title: 'Доставка автомобиля к Заказчику',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="1" y="3" width="15" height="13"></rect>
                    <polygon points="16,8 20,8 23,11 23,16 16,16"></polygon>
                    <circle cx="5.5" cy="18.5" r="2.5"></circle>
                    <circle cx="18.5" cy="18.5" r="2.5"></circle>
                </svg>
            )
        },
        {
            title: 'Таможенное оформление',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="10" y1="12" x2="14" y2="12"></line>
                    <line x1="10" y1="16" x2="14" y2="16"></line>
                </svg>
            )
        },
        {
            title: 'Помощь с постановкой в ГИБДД',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 3v18h18"></path>
                    <path d="M18.7 8a3 3 0 0 0-5.4 0"></path>
                    <path d="M16.5 12.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"></path>
                    <path d="M3 21l6-6"></path>
                </svg>
            )
        }
    ];

    return (
        <div className="services-price-section-redesigned">
            <div className="services-container-redesigned">
                {/* Заголовок секции */}
                <div className="services-header-redesigned">
                    <h2 className="services-main-title-redesigned">Что входит в наши услуги</h2>
                    <div className="services-subtitle-redesigned">
                        Полный комплекс услуг по подбору и покупке автомобилей в Европе
                    </div>
                </div>

                {/* Контент с услугами и ценой */}
                <div className="services-content-redesigned">
                    {/* Список услуг */}
                    <div className="services-list-redesigned">
                        {services.map((service, index) => (
                            <div key={index} className="service-item-redesigned">
                                <div className="service-icon-redesigned">
                                    {service.icon}
                                </div>
                                <div className="service-text-redesigned">
                                    {service.title}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Блок с ценой */}
                    <div className="services-price-card-redesigned">
                        <div className="price-header-redesigned">
                            <div className="price-label-redesigned">Стоимость услуг</div>
                            <div className="price-amount-redesigned">
                                <span className="price-number-redesigned">70 000</span>
                                <span className="price-currency-redesigned">руб.</span>
                            </div>
                        </div>
                        
                        <div className="price-features-redesigned">
                            <div className="price-feature-redesigned">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20,6 9,17 4,12"></polyline>
                                </svg>
                                Работаем по договору
                            </div>
                            <div className="price-feature-redesigned">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20,6 9,17 4,12"></polyline>
                                </svg>
                                Гарантия качества
                            </div>
                            <div className="price-feature-redesigned">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20,6 9,17 4,12"></polyline>
                                </svg>
                                Полное сопровождение
                            </div>
                        </div>

                        <button
                            className="services-cta-button-redesigned"
                            onClick={onOpenApplicationModal}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                            </svg>
                            Оставить заявку
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServicesPrice;